import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const ENV = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development';
const RELEASE = import.meta.env.VITE_SENTRY_RELEASE as string | undefined;

export function initSentry(): void {
  if (!DSN) {
    console.info('[Sentry] DSN unset — error monitoring disabled');
    return;
  }
  Sentry.init({
    dsn: DSN,
    environment: ENV,
    release: RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Session replay is paid-tier — leave commented for now.
      // Sentry.replayIntegration(),
    ],
    // 10% of transactions get APM traces. Drop to 0.0 to disable.
    tracesSampleRate: 0.1,
    // Don't capture PII unless you've reviewed with the user.
    sendDefaultPii: false,
    // Capture unhandled React errors via ErrorBoundary (wired below).
  });
}
